{
  "verse": {
    "loading": "Caricamento versetto...",
    "error": "Impossibile caricare il versetto",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "arabicUnavailable": "(Arabo non disponibile)",
    "english": "Inglese",
    "arabic": "العربية",
    "swapLanguage_aria": "Cambia lingua",
    "toggleLanguage_title": "Alterna Inglese / Arabo",
    "reflect": "Rifletti",
    "reflecting": "Sto pensando…",
    "reflect_aria": "Genera una riflessione personale che collega questo versetto alla tua intenzione",
    "insights": "Approfondimenti",
    "insights_aria": "Apri gli Approfondimenti AI sul Quran",
    "share": "Condividi",
    "share_aria": "Condividi questo versetto come immagine",
    "share_title": "Condividi questo versetto",
    "removeFromFavorites_aria": "Rimuovi dai preferiti",
    "saveToFavorites_aria": "Salva nei preferiti",
    "favoritesProLocked_aria": "I preferiti sono una funzione Pro",
    "favoritesUpgrade_aria": "Passa a Pro per salvare i preferiti",
    "signInToSave": "Accedi per salvare i preferiti.",
    "failedToUpdateFavorites": "Impossibile aggiornare i preferiti",
    "couldNotReflect": "Impossibile generare la riflessione",
    "shareCaption": "\"{{text}}\"\n— Surah {{surah}}, Ayah {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Immagine salvata · versetto copiato",
    "imageSaved": "Immagine del versetto salvata",
    "couldNotCreateImage": "Impossibile creare l'immagine"
  },
  "insights": {
    "panel_aria": "Pannello Approfondimenti sul Quran",
    "title": "Approfondimenti",
    "reference": "Surah {{surah}}, Ayah {{ayah}}",
    "close_aria": "Chiudi pannello Approfondimenti",
    "versePreview_aria": "Anteprima del versetto",
    "back_aria": "Indietro",
    "tryAgain": "Riprova",
    "backTo_aria": "Torna a {{ref}}",
    "copyVerse_aria": "Copia {{ref}}",
    "openingVerse": "Apertura del versetto…",
    "verseError": "Impossibile aprire il versetto."
  },
  "proGate": {
    "title": "Gli Approfondimenti AI sul Quran sono una funzione Pro",
    "subtitleSafari": "Sblocca una comprensione profonda e contestuale di ogni versetto con Rhemn Pro. Già membro? Si sblocca automaticamente all'accesso.",
    "subtitle": "Sblocca una comprensione profonda e contestuale di ogni versetto.",
    "bulletAsk": "Fai qualsiasi domanda sul versetto",
    "bulletTafsir": "Riassunti di Tafsir istantanei basati sull'AI",
    "bulletRelated": "Scopri versetti tematicamente correlati",
    "upgrade": "Passa a Pro"
  },
  "ask": {
    "heading": "Chiedi",
    "suggestion1": "Qual è il contesto più ampio di questo versetto?",
    "suggestion2": "Come posso applicarlo nella vita quotidiana?",
    "suggestion3": "Cosa dicono gli studiosi classici a riguardo?",
    "placeholder": "Chiedi qualsiasi cosa su questo versetto…",
    "input_aria": "Fai una domanda su questo versetto",
    "submit_aria": "Invia domanda",
    "submit_title": "Invia (⌘↵)",
    "submit_label": "Chiedi",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Domande suggerite",
    "error": "Non è stato possibile ottenere una risposta.",
    "pending": "Riflettendo sulla tua domanda…",
    "attribution": "Risposta generata dall'AI · Non sostituisce uno studio qualificato"
  },
  "tafsir": {
    "heading": "Tafsir",
    "emptyText": "Ottieni un riassunto del Tafsir generato dall'AI per questo versetto.",
    "generate": "Genera Tafsir",
    "commentary": "Commento",
    "regenerate": "Rigenera",
    "regenerate_aria": "Rigenera tafsir",
    "attribution": "Riassunto generato dall'AI · Non sostituisce uno studio qualificato",
    "error": "Non è stato possibile generare il tafsir.",
    "pending": "Lettura del commento…"
  },
  "related": {
    "heading": "Versetti correlati",
    "copied": "Copiato: {{ref}}",
    "failedToCopy": "Copia non riuscita",
    "empty": "Nessun versetto correlato trovato.",
    "error": "Non è stato possibile caricare i versetti correlati.",
    "pending": "Ricerca di versetti correlati…"
  },
  "favorites": {
    "panel_aria": "Versetti preferiti",
    "title": "Versetti preferiti",
    "proLocked": "I versetti preferiti sono una funzione Pro.",
    "loading": "Caricamento…",
    "failedToLoad": "Impossibile caricare i preferiti",
    "empty": "Nessun preferito ancora. Tocca il cuore su un versetto per salvarlo.",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "remove_aria": "Rimuovi dai preferiti",
    "failedToRemove": "Rimozione non riuscita"
  }
}
